import React, { useCallback, useState, JSX } from 'react';
import classNames from 'classnames';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';
import { useMessageContext } from '../../message/message.context';

const MAX_SHADOW_HEIGHT = 20;

export const FormInputs = (_props: JSX.IntrinsicElements['div']) => {
	const {
		id, //ignore it to avoid duplicate
		ref, //ignore
		onChange, //ignore
		children,
		style,
		onScroll,
		className,
		...props
	} = cleanBoxProps(_props);

	const { message } = useMessageContext();

	const [bottomShadow, setBottomShadow] = useState<number>(0);
	const [topShadow, setTopShadow] = useState<number>(0);

	const setShadow = useCallback((el: HTMLDivElement | null) => {
		if (el) {
			const { clientHeight, scrollHeight, scrollTop } = el;
			const scrollDiff = scrollHeight - clientHeight - scrollTop;
			const newShadow = Math.round((scrollDiff / 100) * MAX_SHADOW_HEIGHT);

			if (newShadow > MAX_SHADOW_HEIGHT) {
				setBottomShadow(MAX_SHADOW_HEIGHT);
				setTopShadow(0);
			} else {
				setBottomShadow(newShadow);
				setTopShadow(MAX_SHADOW_HEIGHT - newShadow);
			}
		}
	}, []);

	return (
		<div
			className={classNames('form__inputs', className)}
			ref={setShadow}
			onScroll={(e) => {
				onScroll?.(e);
				setShadow(e.currentTarget);
			}}
			style={
				!message
					? {
							...style,
							background: `linear-gradient(to bottom, var(--theme--light-primary) -${
								MAX_SHADOW_HEIGHT * 2
							}px,transparent ${topShadow}px, transparent), linear-gradient(to top, var(--theme--light-primary) -${
								MAX_SHADOW_HEIGHT * 2
							}px, transparent ${bottomShadow}px, transparent)`,
						}
					: style
			}
			{...props}
		>
			{children}
		</div>
	);
};
